import { createTrackingUtils } from "../index.js";
const utils = createTrackingUtils({
    name: "flights_web_apex_ancillaries_aa",
    stages: {
        flight_details: 1,
        branded_fares: 2,
        ticket_type: 3,
        ancillaries_with_flex: 4,
        ancillaries_with_insurance: 5,
        ancillaries_with_cabin_baggage: 6,
        ancillaries_with_cabin_baggage_per_traveller: 7,
        ancillaries_with_checked_baggage: 8,
        seat_map: 9
    },
    goals: { click_next_branded_fare: 1 },
    defaultStage: 1
});
const trackAncillariesStages = (extraProducts, canOfferFlexibleTicket) => {
    extraProducts.travelInsurance && utils.stages.ancillaries_with_insurance();
    extraProducts.cabinBaggagePerTraveller && utils.stages.ancillaries_with_cabin_baggage_per_traveller();
    extraProducts.checkedInBaggage && utils.stages.ancillaries_with_checked_baggage();
    extraProducts.flexibleTicket && canOfferFlexibleTicket && utils.stages.ancillaries_with_flex();
};
export default { ...utils, trackAncillariesStages };
